import React from "react";
import AboutHeading from "../components/AboutHeading";
import Styled from "styled-components";
import PersonalInfo from "../components/PersonalInfo";
import MySkills from "../components/MySkills";
import ExpAndEdu from "../components/ExpAndEdu";
function About() {
  return (
    <MainCont>
      <AboutHeading />
      <PersonalInfo />
      <HLine />
      <MySkills />
      <HLine />
      <ExpAndEdu/>
    </MainCont>
  );
}
const MainCont = Styled.div`
    background:#111111;
    height:fit-content;
    display:flex;
    flex-direction:column;
    gap:4rem;
    padding-left:100px;
    overflow-x:hidden;
    padding-right:100px;
    animation:BottomToTop .9s ease-in-out;
    @media (max-width:425px){
      padding:10px;
    }
`;
const HLine = Styled.hr`
    border:1px solid #32323230;
    width:35vw;
`;
export default About;
